<template>
    <div class="lang arabic">
        <div class="greeting">
            <div class="greeting__inner">
                <div class="greeting__bg"><img src="/resource/img/about-bg02.png" alt=""></div>
                <div class="greeting__tit pc-none">
                    <div class="greeting__tit-inner item1">
                        <div>
                            مرحبا. شكراًلزيارةموقعمركزتعزيزالصحةالصحية‘ويلنيس’.
                        </div>
                    </div>
                </div>
                <div class="greeting__img">
                    <div class="greeting__img-inner">
                        <img src="/resource/img/img_hos01_01.jpg" alt="">
                    </div>
                    <div class="greeting__img-bg"></div>
                </div>
                <div class="greeting__text">
                    <div class="greeting__tit mo-none">
                        <div class="greeting__tit-inner item1">
                            <div>
                                مرحبا. شكراًلزيارةموقعمركزتعزيزالصحةالصحية‘ويلنيس’.
                            </div>
                        </div>
                    </div>
                    <div class="desc">
                        <p>
                            منذافتتاحه،تمحبمركز, مركز الصحة للنساءفيمستشفىييدايموكودون/ مركزتعزيزالصحةكمرافقللرعايةالصحيةمنخلالإنشاءبيئةرعايةمريحةومريحةوصديقةللنساءمعنظامفحصصحيسريعومريحوخدمةمتكاملةتسمحلكبتلقيالرعايةعندالحاجة. بالإضافةإلىذلك،ومعافتتاحمستشفىليدايسولفيعام
                        </p>
    
                        <p>
                            2019،أعلنمركزتعزيزالصحة’ويلنيس’فيمستشفىليدايسيولعنبداياتهكمرفيقلحمايةحياتكالسعيدةوالصحيةبهدف’ويلنيس’وهومايعنيالرفاه(well-being)والعافية(fitness).
                        </p>
    
                        <p>
                            من 1 أبريل 2020،سيتمتوسيعو دمجه من مركزالفحصالصحيفيمركزإيوهاالطبيالىمركزتعزيزالصحة’ويلنيس’فيمستشفىليدايسيول.
                        </p>
    
                        <p>
                            وقدأدىذلكإلىتقديممركزإيوهاالطبيأفضلخدماتالفحصالصحيمنخلالالتشخيصالأكثردقةوالمعداتالطبيةالدقيقةوبيئةالرعايةالسريعةوالمريحة،فضلاًعنمرافقأكثرأناقةوراحة.
                        </p>
                        <p>
                            تتخصصبيئةالرعايةالفريدةوالصديقةللأنثويفيمركزإيوهاالطبيفيالرعايةالصحيةالتيتتطلبرعايةأكثردقة،وستوفرنظامر
                            عايةصحيةمختلفعنذيقبلليسفقطللنساءولكنللرجالأيضًا،وكذلكالأشخاصحولالعالمالذينيحتاجونإلىرعايةصحيةكوريةمتقدمة.
                            مركزتعزيزالصحة’ويلنيس’فيمستشفىلي دايسيولسيكوندائمامعكملمساعدتكعلىالبقاءفيصحةجيدةوتنموفيسعادة
                        </p>
    
    
                        <div class="name">
                            <p>مركزتعزيزالصحةالصحية’ويلنيس’فيمستشفىليدايسيول</p>
                            <span>رئيسالمركزسونغ هاي كيونغ</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { gsap, Power1 } from "gsap";
    import { ScrollTrigger } from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger); // 추가된 부분
    export default {
        methods: {
            gsapAbout() {
                gsap.from(".greeting__img img", {
                    height: 0,
                    duration: 1,
                    delay: .5,
                });
                gsap.from(".greeting__img img", {
                    scale: 1.2,
                    duration: 4,
                    delay: 1.4,
                });
                gsap.from(".greeting__img-bg", {
                    opacity: 0,
                    x: 0,
                    y: 0,
                    duration: 1,
                    delay: 1.5,
                });
                gsap.from(".greeting__tit .item2 em span", {
                    width: 0,
                    duration: 1.5,
                    delay: 2,
                    ease: Power1.easeInOut,
                    // onComplete: () => {
                    //     gsap.to(".greeting__tit .item2 em span", {
                    //         backgroundColor: 'var(--aorta-P10)',
                    //         duration: 1.5
                    //     });
                    // }
                });
                gsap.from(".item1 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".item2 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".desc", {
                    opacity: 0,
                    y: 30,
                    duration: 1,
                    delay: 2.8,
                });
                gsap.from(".greeting__bg", {
                    opacity: 0,
                    duration: 3,
                    delay: 1,
                });

            }
        },
        mounted() {
            if (window.innerWidth >= 1025) {
                this.gsapAbout();
            }
        },
    }

</script>
<style>

</style>